import { usePriorStats } from "../hooks/useOcrHealthData";
import styles from "../ocr-health.module.css";
import { PanelCard, PanelError, PanelStatus } from "./PanelCard";

export function PriorApplicationStats() {
  const { data, isLoading, error } = usePriorStats();

  if (isLoading) return <PanelCard title="Prior Application (last 24h)"><PanelStatus>Loading…</PanelStatus></PanelCard>;
  if (error) return <PanelCard title="Prior Application (last 24h)"><PanelError>Couldn't load — {error}</PanelError></PanelCard>;
  if (!data) return <PanelCard title="Prior Application (last 24h)"><PanelStatus>No data</PanelStatus></PanelCard>;

  return (
    <PanelCard title="Prior Application (last 24h)">
      <div className={styles.statGrid}>
        <Stat label="% extracts w/ prior" value={`${(data.pctWithPrior * 100).toFixed(1)}%`} />
        <Stat label="Avg boost magnitude" value={`±${data.avgBoostMagnitude.toFixed(2)}`} />
        <Stat label="Total recent extracts" value={data.recentExtractCount.toString()} />
        <Stat label="Active profiles" value={data.profilesWithActivePriors.toString()} />
      </div>
    </PanelCard>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className={styles.statValue}>{value}</div>
      <div className={styles.statLabel}>{label}</div>
    </div>
  );
}
